
import ApiGenericServicesData from 'services/ApiGenericServicesData';

export default class ActaVencimientoDePlazoParaDeclararCambioDeResidenciaDeUnMunicipioAOtro extends ApiGenericServicesData{
    constructor(){
        super("actaVencimientoDePlazoParaDeclararCambioDeResidenciaDeUnMunicipioAOtro");
    }
    ActaVencimientoPdf(data) { return this.customPATCH("ActaVencimientoPdf",data); }  
}